import { createSelector } from 'reselect';
import { RootState } from '../configureStore';

const selectPersonalityReducer = (state: RootState) => state.personality;

const selectCurrentPersonality = createSelector(selectPersonalityReducer, (data) => data.currentPersonality);
const selectCurrentPersonalitySection = createSelector(selectPersonalityReducer, (data) => data.currentPersonalitySection);

export { selectCurrentPersonality, selectCurrentPersonalitySection };
